// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"ec03e55c6f913b817459","elc-service-ratings-reviews-common":"0a6364f2e29e8c4d05d9","ProductRating":"2e9c9408c9a0268ec00f","ProductReviews":"bea528c78eb537110742","ReviewDetails":"111faf9e449f7b8e3767"}[chunkId] + ".bundle.js";
};